module.exports = __webpack_public_path__ + "images/marketing_site/blog_headshot/nic_cary.jpg";